<template>
  <modal :title="title" @close="$emit('close')" :show-close-button="true" class="modal__success">
    <div class="form-card">
      <flash-message target="stripe"></flash-message>
      <ValidationProvider rules="required" name="Card" tag="div">
        <label for="card" class="form-card__label">Use existing payment method</label>
        <select name="card" id="card" class="form-card__select" v-model="localCardId">
          <option v-for="card in customer.cards" :value="card.id" :key="card.id">**** **** **** {{ card.last4 }}
          </option>
        </select>
      </ValidationProvider>
      <p class="form-card__text form-card__text--center"><button class="btn btn-text" @click="$emit('swap')">Pay with new card</button></p>
      <v-button class="btn btn-primary btn-block form-card__button" @click="cb(cardId)" group="subscribe" v>{{ displayPrice }}</v-button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/utils/Modal';
import ModalJS from '@/components/classes/Modal';
import HelpersMixin from '@/components/mixins/HelpersMixin';
import Button from '@/components/utils/Button';

export default {
  name: 'subscribe-with-card-modal',
  mixins: [HelpersMixin],
  components: {
    Modal,
    'v-button': Button,
  },
  props: {
    cardId: {
      required: true,
    },
    price: {
      required: true,
      type: Object,
    },
    currency: {
      required: true,
      type: Object,
    },
    cb: {
      required: true,
      type: Function,
    },
    customer: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      modal: new ModalJS({
        subscribe: false,
      }),
      localCardId: this.cardId,
    };
  },
  computed: {
    title() {
      if (this.price === null) return '';
      let durationUnit = null;
      if (this.price.duration_unit === 'month') {
        durationUnit = 'Monthly';
      }
      if (this.price.duration_unit === 'year') {
        durationUnit = 'Yearly';
      }
      return `${durationUnit} subscription`;
    },
    displayPrice() {
      const p = this.getAmountFromPrice(this.price);
      return `pay ${this.currency.symbol}${p}`;
    },
  },
};
</script>
